export type AssignedToFilter = (typeof AssignedToFilter)[keyof typeof AssignedToFilter];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AssignedToFilter = {
  ME: 'ME',
  ALL: 'ALL',
  UNASSIGNED: 'UNASSIGNED',
  SPECIFIC: 'SPECIFIC',
} as const;
